import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import StaticPostLayout from '../components/StaticPostLayout';
import InfoSection from '../components/TripInfo/colorado-river';
import MapSection from '../components/Maps/colorado-river';

class KayakColoradoRiver extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>2-Day Colorado River Kayaking Trip (Page, AZ)</title>
          <meta name="description" content="Plan a 2-day Colorado River kayak trip near Page, AZ with a Lee's Ferry backhaul, riverside camping, Antelope Canyon tour, and Horseshoe Bend sunset hike." />
          <meta property="og:title" content="2-Day Colorado River Kayaking Trip (Page, AZ)" />
          <meta property="og:description" content="Plan a 2-day Colorado River kayak trip near Page, AZ with a Lee's Ferry backhaul, riverside camping, Antelope Canyon tour, and Horseshoe Bend sunset hike." />
          <meta property="og:url" content="https://exploroff.com/itineraries/kayak-colorado-river" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content="https://exploroff.com/img/kayak-colorado-river/two-day-kayak-rental.png" />
          <link rel="canonical" href="https://exploroff.com/itineraries/kayak-colorado-river" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org", "@type": "BlogPosting",
            headline: "2-Day Colorado River Kayaking Trip (Page, AZ)",
            description: "Plan a 2-day Colorado River kayak trip near Page, AZ with a Lee's Ferry backhaul, riverside camping, Antelope Canyon tour, and Horseshoe Bend sunset hike.",
            image: ["https://exploroff.com/img/kayak-colorado-river/two-day-kayak-rental.png"],
            author: { "@type": "Organization", name: "ExplorOFF" },
            publisher: { "@type": "Organization", name: "ExplorOFF", logo: { "@type": "ImageObject", url: "https://exploroff.com/img/favicon.png" } },
            mainEntityOfPage: { "@type": "WebPage", "@id": "https://exploroff.com/itineraries/kayak-colorado-river" }
          })}</script>
        </Helmet>
        <MessengerCustomerChat pageId="101590111335192" appId="695593052231950" />
        <StaticPostLayout
          title="2-Day Colorado River Kayaking Trip"
          category="itineraries"
          slug="kayak-colorado-river"
          excerpt="Lee's Ferry backhaul, riverside camping, Antelope Canyon, and Horseshoe Bend — the Southwest's most spectacular two-day paddle."
          tags={['planning', 'navigation']}
          readTime={9}
          mapComponent={<MapSection />}
          whereToStay={[
            { name: 'Hotels in Page', type: "Lee's Ferry Gateway · Page, AZ", url: 'https://www.booking.com/searchresults.html?ss=Page%2C+Arizona' },
            { name: 'Lake Powell Resorts', type: 'Lake Powell · Page, AZ', url: 'https://www.booking.com/searchresults.html?ss=Page%2C+Arizona' },
            { name: 'Cameron Trading Post', type: 'Desert Motel · Cameron, AZ', url: 'https://www.booking.com/searchresults.html?ss=Cameron%2C+Arizona' },
          ]}
        >
          <InfoSection />
        </StaticPostLayout>
      </>
    );
  }
}

export default KayakColoradoRiver;
